
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Info } from 'lucide-react';
import { RawResponseDisplay } from './RawResponseDisplay';

interface EnrichmentFallbackDialogContentProps {
  clientName: string; 
  message: string;
  rawResponse: Record<string, unknown> | unknown[] | null;
}

export const EnrichmentFallbackDialogContent: React.FC<EnrichmentFallbackDialogContentProps> = ({
  message,
  rawResponse,
  // clientName is available if needed for title or messages
}) => (
  <>
    <Alert variant="warning" className="my-4">
      <Info className="h-4 w-4" />
      <AlertTitle>Unexpected Enrichment Status</AlertTitle>
      <AlertDescription>
        <p>{message}</p>
      </AlertDescription>
    </Alert>
    {rawResponse && (
      (typeof rawResponse === 'object' && rawResponse !== null && (
        (Array.isArray(rawResponse) && rawResponse.length > 0) ||
        (!Array.isArray(rawResponse) && Object.keys(rawResponse).length > 0)
      )) && (
      <RawResponseDisplay
        title="Raw Debug Information (Fallback)"
        data={rawResponse}
        maxHeight="max-h-60"
      />
    ))}
  </>
);
